/**
 * Parse a variety of coordinate formats into a standardized lat/lng object
 */
export function parseGeoCoordinates(value: unknown): { lat: number; lng: number } | null {
  try {
    if (!value) return null;

    // Handle array format [lat, lng]
    if (Array.isArray(value) && value.length === 2) {
      const lat = Number(value[0]);
      const lng = Number(value[1]);
      if (!isNaN(lat) && !isNaN(lng)) {
        return { lat, lng };
      }
    }
    // Handle string format "[lat, lng]" or "lat, lng"
    else if (typeof value === 'string') {
      const cleanStr = value.replace(/[\[\]{}()\s]/g, '');
      const parts = cleanStr.split(',');
      if (parts.length === 2) {
        const lat = parseFloat(parts[0]);
        const lng = parseFloat(parts[1]);
        if (!isNaN(lat) && !isNaN(lng)) {
          return { lat, lng };
        }
      }
    }
    // Handle object format {lat, lng}
    else if (typeof value === 'object' && value !== null) {
      const obj = value as Record<string, unknown>;
      if ('lat' in obj && 'lng' in obj) {
        const lat = Number(obj.lat);
        const lng = Number(obj.lng);
        if (!isNaN(lat) && !isNaN(lng)) {
          return { lat, lng };
        }
      }
    }
    return null;
  } catch (e) {
    console.error("Error parsing geo coordinates", e);
    return null;
  }
}

/**
 * Format coordinates as a string in the format [lat, lng]
 */
export function formatGeoCoordinates(coordinates: { lat: number; lng: number }, precision = 6): string {
  return `[${coordinates.lat.toFixed(precision)}, ${coordinates.lng.toFixed(precision)}]`;
}
